import { getUrlAssets } from '../constants';
import { useTranslation } from '../hooks/useTranslation';
import InstallmentsDropdown from './InstallmentsDropdown';

const NETWORK_ICONS = {
  VISA: '/card_brand_visa_color.svg',
  MASTERCARD: '/card_brand_mscd.svg',
  AMEX: '/card_brand_amex.svg',
  DISCOVER: '/card_brand_disc.svg'
};

export default function GooglePayInstallmentsView({ cardNetwork, cardLast4, installments, i18n, selected, onSelect }) {
  const { tBackend } = useTranslation();
  const networkIcon = NETWORK_ICONS[cardNetwork];

  const i18nSafe = i18n || {};

  return (
    <div className="gpay-installments-view">
      <div className="gpay-installments-header">
        <div className="gpay-installments-title">{tBackend(i18nSafe.title)}</div>
        <div className="gpay-installments-subtitle">{tBackend(i18nSafe.subtitle)}</div>
      </div>

      <div className="gpay-installments-card">
        {networkIcon && (
          <img className="gpay-installments-card-network" src={getUrlAssets() + networkIcon} alt={cardNetwork} />
        )}
        <div className="gpay-installments-card-info">
          <div className="gpay-installments-card-number">&bull;&bull;&bull;&bull; {cardLast4}</div>
          <div className="gpay-installments-card-label">{tBackend(i18nSafe.credit_label)}</div>
        </div>
      </div>

      <InstallmentsDropdown
        options={installments}
        selected={selected}
        onSelect={onSelect}
        labelEntry={i18nSafe.installments_label}
        fieldClassName="field gpay-installments-dropdown"
      />
    </div>
  );
}
